export const siteName = "Skyheight";

export const email = "support@privateskyheight.icu";
